import { Component } from '@angular/core';

@Component({
  selector: 'edge-football-content',
  templateUrl: './football-content.component.html',
  styleUrls: ['./football-content.component.scss']
})
export class FootballContentComponent {
  features = [
    {
      image: 'football-screenshot-1.jpg',
      title: 'Draw and Edit Your Plays',
      description: `
        Draw routes, passes, handoffs, interceptions, pre-snap motions, and
        more to create plays and build playbooks. Add huddles, shifts, set the ball on
        a hash, precisely align players, and save custom route trees.`
    },
    {
      image: 'football-screenshot-2.jpg',
      title: 'See Your Plays in Real-Time 3D',
      description: `
        See plays in 2D or in 3D on a virtual field with accurate animations, timing
        and ball-handling. View from any camera angle or player perspective to
        see it as they do on the field. View plays in real-time, speed, or 2x speed.`
    },
    {
      image: 'football-screenshot-3.jpg',
      title: 'Whiteboard',
      description: `
        Instantly draw plays and move players around in the pre-populated
        whiteboard mode for quick sketches of football alignments and concepts.`
    }
  ];

  additionalFeatures = [
    {
      title: 'Precision Player Movements',
      description: `
      Use the play editor to fine-tune player movements such as first steps, cuts,
      option handoffs, and more, in order to illustrate plays accurately.`
    },
    {
      title: 'Create Custom Drills',
      description: `
      Set up Drills to teach and quiz formations, plays alignments, reads, keys,
      coverages, and blitzes, for players to review on their own with notes from
      the coach.`
    },
    {
      title: 'Customize Uniforms',
      description: `
      Customize uniforms to match team colors, style, and jersey numbers for your
      team and upcoming opponents.`
    }
  ];
}
